(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3289,8318],{

/***/ 72097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Image; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconImageClose/index.js
var IconImageClose = __webpack_require__(81485);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/utils/hooks/useShowFooter.js
function useShowFooter(props) {
    var title = props.title, description = props.description, actions = props.actions;
    var showCaption = title || description;
    var showActions = actions && actions.length;
    var showFooter = showCaption || showActions;
    return [showFooter, showCaption, showActions];
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMore/index.js
var IconMore = __webpack_require__(47962);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/trigger-for-toolbar.js
var trigger_for_toolbar = __webpack_require__(82411);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/image-footer.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var ImageFooter = function (props) {
    var _a;
    var style = props.style, className = props.className, title = props.title, description = props.description, actions = props.actions, prefixCls = props.prefixCls, simple = props.simple;
    var _b = __read(useShowFooter({ title: title, description: description, actions: actions }), 3), showFooter = _b[0], showCaption = _b[1], showActions = _b[2];
    if (!showFooter)
        return null;
    var footerPrefixCls = prefixCls + "-footer";
    var classNames = (0,_util_classNames/* default */.Z)(footerPrefixCls, className, (_a = {},
        _a[footerPrefixCls + "-with-actions"] = showActions,
        _a));
    var renderActionList = function () {
        var actionsList = (react.createElement("div", { className: prefixCls + "-actions-list" }, actions.map(function (item, index) {
            return (react.createElement("div", { className: prefixCls + "-actions-item", key: "" + index }, item));
        })));
        if (simple) {
            return (react.createElement("div", { className: prefixCls + "-actions-list" },
                react.createElement(trigger_for_toolbar/* TriggerForToolbar */.y, { prefixCls: prefixCls, popup: function () { return actionsList; } },
                    react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-actions-item", prefixCls + "-actions-item-trigger") },
                        react.createElement("span", null,
                            react.createElement(IconMore/* default */.Z, null))))));
        }
        return actionsList;
    };
    return (react.createElement("div", { className: classNames, style: style },
        showCaption && (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(footerPrefixCls + "-block", prefixCls + "-caption") },
            title && (react.createElement("div", { className: prefixCls + "-caption-title", title: title }, title)),
            description && !simple && (react.createElement("div", { className: prefixCls + "-caption-description", title: description }, description)))),
        showActions && (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(footerPrefixCls + "-block", prefixCls + "-actions") }, renderActionList()))));
};

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview.js + 4 modules
var image_preview = __webpack_require__(88765);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview-group.js
var image_preview_group = __webpack_require__(65808);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/utils/hooks/useImageStatus.js
var useImageStatus = __webpack_require__(83062);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/previewGroupContext.js
var previewGroupContext = __webpack_require__(83417);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dom.js
var dom = __webpack_require__(53412);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIntersectionObserver.js



var supportIntersectionObserver = !dom/* isServerRendering */.ET && !(0,is/* isUndefined */.o8)(window === null || window === void 0 ? void 0 : window.IntersectionObserver);
function useIntersectionObserver(callback, options) {
    if (options === void 0) { options = {}; }
    var intersectionObserver = (0,react.useRef)();
    var destroyObserver = function () {
        if (intersectionObserver.current) {
            intersectionObserver.current.disconnect();
            intersectionObserver.current = null;
        }
    };
    var createObserver = function (elem) {
        if (elem) {
            destroyObserver();
            if (supportIntersectionObserver) {
                intersectionObserver.current = new IntersectionObserver(callback, options);
                intersectionObserver.current.observe(elem);
            }
        }
    };
    return {
        observer: intersectionObserver.current,
        cor: createObserver,
        dor: destroyObserver,
    };
}
/* harmony default export */ var hooks_useIntersectionObserver = (useIntersectionObserver);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useInView.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var useInView_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


function useInView(props) {
    var defaultInView = props.defaultInView, _a = props.unobserverOnEnter, unobserverOnEnter = _a === void 0 ? true : _a, onChange = props.onChange, target = props.target, rest = __rest(props, ["defaultInView", "unobserverOnEnter", "onChange", "target"]);
    // if intersect observer is not supported
    var _b = useInView_read((0,react.useState)(supportIntersectionObserver ? defaultInView : true), 2), inView = _b[0], setInView = _b[1];
    var observerCallback = (0,react.useCallback)(function (_a, observer) {
        var _b = useInView_read(_a, 1), entry = _b[0];
        var inThreshold = observer.thresholds.some(function (t) { return entry.intersectionRatio >= t; });
        var newInView = inThreshold && entry.isIntersecting;
        setInView(newInView);
        onChange === null || onChange === void 0 ? void 0 : onChange(newInView, entry);
        if (newInView && unobserverOnEnter) {
            observer.unobserve(entry.target);
        }
    }, [onChange, unobserverOnEnter]);
    var _c = hooks_useIntersectionObserver(observerCallback, rest), cor = _c.cor, dor = _c.dor, observer = _c.observer;
    (0,react.useEffect)(function () {
        var noNeedObserver = defaultInView && unobserverOnEnter;
        if (noNeedObserver) {
            dor();
        }
        else if (target) {
            cor(target);
        }
        return dor;
    }, [target, defaultInView, unobserverOnEnter]);
    return {
        inView: inView,
        observer: observer,
    };
}
/* harmony default export */ var hooks_useInView = (useInView);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/image.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var image_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var image_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

















var uuid = 0;
var defaultProps = {
    footerPosition: 'inner',
    preview: true,
};
function Image(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Image);
    var style = props.style, className = props.className, src = props.src, width = props.width, height = props.height, title = props.title, description = props.description, actions = props.actions, footerPosition = props.footerPosition, simple = props.simple, loader = props.loader, loaderClassName = props.loaderClassName, error = props.error, preview = props.preview, _propsPreviewProps = props.previewProps, alt = props.alt, onClick = props.onClick, index = props.index, _index = props._index, onError = props.onError, onLoad = props.onLoad, lazyload = props.lazyload, restProps = image_rest(props, ["style", "className", "src", "width", "height", "title", "description", "actions", "footerPosition", "simple", "loader", "loaderClassName", "error", "preview", "previewProps", "alt", "onClick", "index", "_index", "onError", "onLoad", "lazyload"]);
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var _c = (0,react.useContext)(previewGroupContext/* PreviewGroupContext */.v), previewGroup = _c.previewGroup, handleGroupVisibleChange = _c.handleVisibleChange, registerPreviewUrl = _c.registerPreviewUrl, registerPreviewProps = _c.registerPreviewProps, setCurrentIndex = _c.setCurrentIndex;
    var previewProps = (0,react.useMemo)(function () {
        return (0,is/* isObject */.Kn)(_propsPreviewProps) ? _propsPreviewProps : {};
    }, [_propsPreviewProps]);
    var intersectionInitOptions = (0,react.useMemo)(function () {
        return (0,is/* isObject */.Kn)(lazyload) ? lazyload : {};
    }, [lazyload]);
    var id = (0,react.useMemo)(function () {
        if ((0,is/* isNumber */.hj)(index) || (0,is/* isNumber */.hj)(_index)) {
            uuid = (0,is/* isNumber */.hj)(index) ? index : _index;
            return uuid;
        }
        return uuid++;
    }, []);
    var previewSrc = previewProps.src || src;
    var _d = image_read(useShowFooter({ title: title, description: description, actions: actions }), 1), showFooter = _d[0];
    var _e = (0,useImageStatus/* default */.Z)('beforeLoad'), isLoading = _e.isLoading, isError = _e.isError, isLoaded = _e.isLoaded, isLazyLoad = _e.isLazyLoad, isBeforeLoad = _e.isBeforeLoad, setStatus = _e.setStatus;
    var _f = image_read((0,useMergeValue/* default */.Z)(false, {
        defaultValue: previewProps.defaultVisible,
        value: previewProps.visible,
    }), 2), previewVisible = _f[0], setPreviewVisible = _f[1];
    // Props passed directly into Preview component
    var availablePreviewProps = (0,react.useMemo)(function () {
        return (0,omit/* default */.Z)(previewProps, ['visible', 'defaultVisible', 'src', 'onVisibleChange']);
    }, [previewProps]);
    var prefixCls = getPrefixCls('image');
    var isControlled = !(0,is/* isUndefined */.o8)(previewProps.visible);
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-rtl"] = rtl,
        _a[prefixCls + "-simple"] = simple,
        _a[prefixCls + "-before-load"] = isBeforeLoad,
        _a[prefixCls + "-loading"] = isLoading,
        _a[prefixCls + "-loading-error"] = isError,
        _a[prefixCls + "-with-footer-inner"] = isLoaded && showFooter && footerPosition === 'inner',
        _a[prefixCls + "-with-footer-outer"] = isLoaded && showFooter && footerPosition === 'outer',
        _a[prefixCls + "-with-preview"] = isLoaded && preview && !isError && !isControlled,
        _a), className);
    var refImg = (0,react.useRef)();
    function onImgLoaded(e) {
        setStatus('loaded');
        onLoad && onLoad(e);
    }
    function onImgLoadError(e) {
        setStatus('error');
        onError && onError(e);
    }
    function onImgClick(e) {
        if (preview && previewGroup) {
            setCurrentIndex(id);
            handleGroupVisibleChange(true);
        }
        else if (preview) {
            togglePreviewVisible(true);
        }
        onClick && onClick(e);
    }
    function togglePreviewVisible(newVisible) {
        previewProps.onVisibleChange && previewProps.onVisibleChange(newVisible, previewVisible);
        setPreviewVisible(newVisible);
    }
    var inView = hooks_useInView(__assign({ target: refImg.current, defaultInView: !lazyload }, intersectionInitOptions)).inView;
    (0,react.useEffect)(function () {
        if (refImg.current) {
            if (inView) {
                // avoid set img.src to undefined when its doesn't have [src] attribute
                if ((refImg.current.src || src) && refImg.current.src !== src) {
                    refImg.current.src = src;
                    setStatus('loading');
                }
            }
            else {
                setStatus('lazyload');
            }
        }
    }, [src, inView]);
    (0,react.useEffect)(function () {
        if (!previewGroup)
            return;
        var unRegister = registerPreviewProps(id, availablePreviewProps);
        return function () { return unRegister(id); };
    }, [id, previewGroup, availablePreviewProps]);
    (0,react.useEffect)(function () {
        if (!previewGroup)
            return;
        var unRegister = registerPreviewUrl(id, previewSrc, preview);
        return function () { return unRegister(id); };
    }, [id, previewGroup, previewSrc, preview]);
    var defaultError = (react.createElement("div", { className: prefixCls + "-error" },
        react.createElement("div", { className: prefixCls + "-error-icon" },
            react.createElement(IconImageClose/* default */.Z, null)),
        alt && react.createElement("div", { className: prefixCls + "-error-alt" }, alt)));
    var defaultLoader = (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-loader", loaderClassName) },
        react.createElement("div", { className: prefixCls + "-loader-spin" },
            react.createElement(IconLoading/* default */.Z, null),
            react.createElement("div", { className: prefixCls + "-loader-spin-text" }, "Loading"))));
    var renderLoader = function () {
        if (loader === true)
            return defaultLoader;
        var loadElem = loader || defaultLoader;
        // 懒加载展示占位。
        if (lazyload || loader) {
            return loadElem;
        }
        return null;
    };
    return (react.createElement("div", { className: classNames, style: Object.assign({ width: width, height: height }, style), ref: ref },
        react.createElement("img", __assign({ ref: refImg, className: prefixCls + "-img", tabIndex: 0 }, getKeyboardEvents({
            onPressEnter: onImgClick,
        }), restProps, (lazyload || src === undefined ? {} : { src: src }), { title: title, width: width, height: height, onLoad: onImgLoaded, onError: onImgLoadError, onClick: onImgClick, alt: alt })),
        !isLoaded && (react.createElement("div", { className: prefixCls + "-overlay" },
            isError && (error || defaultError),
            (isLoading || isLazyLoad) && renderLoader())),
        isLoaded && showFooter && (react.createElement(ImageFooter, { title: title, description: description, actions: actions, prefixCls: prefixCls, simple: simple })),
        isLoaded && preview && (react.createElement(image_preview/* default */.Z, __assign({ visible: previewVisible, src: previewSrc }, availablePreviewProps, { onVisibleChange: togglePreviewVisible })))));
}
var RefImageComponent = react.forwardRef(Image);
var ImageComponent = RefImageComponent;
ImageComponent.Preview = image_preview/* default */.Z;
ImageComponent.PreviewGroup = image_preview_group/* default */.Z;
ImageComponent.displayName = 'Image';
/* harmony default export */ var Image_image = (ImageComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/index.js

/* harmony default export */ var es_Image = (Image_image);


/***/ }),

/***/ 749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Skeleton/text.js



function text_text(props) {
    var style = props.style, _a = props.width, width = _a === void 0 ? '60%' : _a, _b = props.rows, rows = _b === void 0 ? 3 : _b, className = props.className, prefixCls = props.prefixCls;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls + "-text", className);
    var nodes = [];
    function getTextWidth(index) {
        if ((0,is/* isArray */.kJ)(width)) {
            return width[index];
        }
        if (rows - 1 === index) {
            return width;
        }
        return undefined;
    }
    for (var i = 0; i < rows; i++) {
        nodes.push(react.createElement("li", { className: prefixCls + "-text-row", key: i, style: { width: getTextWidth(i) } }));
    }
    return (react.createElement("ul", { className: classNames, style: style }, nodes));
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Skeleton/image.js


function image_image(props) {
    var _a;
    var style = props.style, _b = props.shape, shape = _b === void 0 ? 'square' : _b, size = props.size, _c = props.position, position = _c === void 0 ? 'left' : _c, className = props.className, prefixCls = props.prefixCls;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls + "-image", (_a = {},
        _a[prefixCls + "-image-" + position] = position,
        _a[prefixCls + "-image-" + shape] = shape,
        _a[prefixCls + "-image-" + size] = size,
        _a), className);
    return react.createElement("div", { className: classNames, style: style });
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pick.js
var pick = __webpack_require__(9472);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Skeleton/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








function getComponentProps(prop) {
    return (0,is/* isObject */.Kn)(prop) ? prop : {};
}
var defaultProps = {
    text: true,
    loading: true,
};
function Skeleton(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Skeleton);
    var style = props.style, className = props.className, animation = props.animation, loading = props.loading, image = props.image, text = props.text, children = props.children;
    var imageProps = getComponentProps(image);
    var textProps = getComponentProps(text);
    var prefixCls = getPrefixCls('skeleton');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-animate"] = animation,
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    function renderImage() {
        return (image && (react.createElement("div", { className: prefixCls + "-header" },
            react.createElement(image_image, __assign({ prefixCls: prefixCls }, imageProps)))));
    }
    function renderText() {
        return (text && (react.createElement("div", { className: prefixCls + "-content" },
            react.createElement(text_text, __assign({ prefixCls: prefixCls }, textProps)))));
    }
    return (react.createElement(react.Fragment, null, loading ? (react.createElement("div", __assign({}, (0,pick/* pickDataAttributes */.m)(props), { className: classNames, style: style, ref: ref }),
        imageProps.position !== 'right' && renderImage(),
        renderText(),
        imageProps.position === 'right' && renderImage())) : (children)));
}
var SkeletonComponent = (0,react.forwardRef)(Skeleton);
SkeletonComponent.displayName = 'Skeleton';
/* harmony default export */ var es_Skeleton = (SkeletonComponent);


/***/ }),

/***/ 7912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Statistic; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/b-tween/dist/b-tween.es.js
var b_tween_es = __webpack_require__(37213);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dayjs.js
var dayjs = __webpack_require__(50381);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pad.js
var pad = __webpack_require__(33091);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Statistic/util.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

// https://github.com/ant-design/ant-design/blob/master/components/statistic/utils.tsx
var units = [
    ['Y', 1000 * 60 * 60 * 24 * 365],
    ['M', 1000 * 60 * 60 * 24 * 30],
    ['D', 1000 * 60 * 60 * 24],
    ['H', 1000 * 60 * 60],
    ['m', 1000 * 60],
    ['s', 1000],
    ['S', 1], // million seconds
];
function getDateString(millisecond, format) {
    var leftMillisecond = millisecond;
    return units.reduce(function (current, _a) {
        var _b = __read(_a, 2), name = _b[0], unit = _b[1];
        if (current.indexOf(name) !== -1) {
            var value_1 = Math.floor(leftMillisecond / unit);
            leftMillisecond -= value_1 * unit;
            return current.replace(new RegExp(name + "+", 'g'), function (match) {
                var len = match.length;
                return (0,pad/* padStart */.S)(value_1.toString(), len, '0');
            });
        }
        return current;
    }, format);
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Statistic/countdown.js
var countdown_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







function Countdown(props, ref) {
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var className = props.className, style = props.style, title = props.title, styleValue = props.styleValue, value = props.value, onFinish = props.onFinish, renderFormat = props.renderFormat, _a = props.format, format = _a === void 0 ? 'HH:mm:ss' : _a, _b = props.start, start = _b === void 0 ? true : _b;
    var dayjsValue = (0,dayjs/* getDayjsValue */.p3)(value, format) || dayjs_min_default()();
    var now = (0,dayjs/* getDayjsValue */.p3)(props.now, format);
    var prefixCls = getPrefixCls('statistic');
    var _c = countdown_read((0,react.useState)(dayjsValue.diff(now, 'millisecond')), 2), valueDiff = _c[0], setValueDiff = _c[1];
    var _d = countdown_read((0,react.useState)(getDateString(Math.max(valueDiff, 0), format)), 2), valueShow = _d[0], setValueShow = _d[1];
    var timerRef = (0,react.useRef)(null);
    var stopTimer = function () {
        clearInterval(timerRef.current);
        timerRef.current = null;
    };
    var startTimer = function () {
        timerRef.current = setInterval(function () {
            var _valueDiff = dayjsValue.diff((0,dayjs/* getNow */.Iz)());
            var _value = dayjsValue.diff((0,dayjs/* getNow */.Iz)(), 'millisecond');
            if (_value <= 0) {
                stopTimer();
                onFinish && onFinish();
            }
            var valueShow = getDateString(Math.max(_value, 0), format);
            setValueShow(valueShow);
            setValueDiff(_valueDiff);
        }, 1000 / 30);
    };
    (0,react.useEffect)(function () {
        if (!timerRef.current && start) {
            if (dayjsValue.valueOf() >= Date.now()) {
                startTimer();
            }
        }
        return function () {
            stopTimer();
        };
    }, [props.start]);
    var valueShowNode = (0,is/* isFunction */.mf)(renderFormat) ? renderFormat(valueDiff, valueShow) : valueShow;
    return (react.createElement("div", { ref: ref, className: (0,classNames/* default */.Z)("" + prefixCls, prefixCls + "-countdown", className), style: style },
        title && react.createElement("div", { className: prefixCls + "-title" }, title),
        react.createElement("div", { className: prefixCls + "-content" },
            react.createElement("div", { className: prefixCls + "-value", style: styleValue }, valueShowNode))));
}
var CountdownComponent = (0,react.forwardRef)(Countdown);
CountdownComponent.displayName = 'StatisticCountdown';
/* harmony default export */ var countdown = (CountdownComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Skeleton/index.js + 2 modules
var Skeleton = __webpack_require__(749);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Statistic/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var Statistic_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var defaultProps = {
    countFrom: 0,
    countDuration: 2000,
};
function Statistic(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Statistic);
    var className = props.className, style = props.style, title = props.title, extra = props.extra, groupSeparator = props.groupSeparator, precision = props.precision, prefix = props.prefix, suffix = props.suffix, format = props.format, renderFormat = props.renderFormat, styleValue = props.styleValue, styleDecimal = props.styleDecimal, loading = props.loading, rest = __rest(props, ["className", "style", "title", "extra", "groupSeparator", "precision", "prefix", "suffix", "format", "renderFormat", "styleValue", "styleDecimal", "loading"]);
    var tween = (0,react.useRef)();
    var _c = Statistic_read((0,react.useState)('value' in props ? props.value : undefined), 2), value = _c[0], setValue = _c[1];
    var prefixCls = getPrefixCls('statistic');
    var countUp = function (from, to) {
        if (from === void 0) { from = props.countFrom; }
        if (to === void 0) { to = props.value; }
        var countDuration = props.countDuration;
        if (from !== to) {
            tween.current = new b_tween_es/* default */.Z({
                from: {
                    value: from,
                },
                to: {
                    value: to,
                },
                duration: countDuration,
                easing: 'quartOut',
                onUpdate: function (keys) {
                    setValue(keys.value.toFixed(precision));
                },
                onFinish: function () {
                    setValue(to);
                },
            });
            tween.current.start();
        }
    };
    (0,react.useEffect)(function () {
        if (props.countUp) {
            if (tween.current) {
                tween.current.stop();
            }
            if (value !== props.value) {
                countUp(Number(value), props.value);
            }
            else {
                countUp();
            }
        }
        else {
            setValue(props.value);
        }
        return function () {
            tween.current && tween.current.stop();
            tween.current = null;
        };
    }, [props.value]);
    (0,react.useImperativeHandle)(ref, function () { return ({
        countUp: countUp,
    }); });
    var _d = (0,react.useMemo)(function () {
        var _value = value;
        if (format) {
            _value = dayjs_min_default()(value).format(format);
        }
        if ((0,is/* isNumber */.hj)(precision) && precision >= 0) {
            _value = Number(value).toFixed(precision);
        }
        var int = String(_value).split('.')[0];
        var decimal = String(_value).split('.')[1];
        if (groupSeparator && (0,is/* isNumber */.hj)(Number(value))) {
            int = Number(int).toLocaleString('en-US');
        }
        return {
            int: int,
            decimal: decimal,
        };
    }, [format, groupSeparator, precision, value]), int = _d.int, decimal = _d.decimal;
    var valueFormatted = (0,is/* isFunction */.mf)(renderFormat)
        ? renderFormat
        : function (_, formattedValue) { return formattedValue; };
    var isNumberValue = (0,is/* isNumber */.hj)(Number(value));
    var eleValueWithPrefix = (react.createElement(react.Fragment, null,
        prefix !== null && prefix !== undefined ? (react.createElement("span", { className: prefixCls + "-value-prefix" }, prefix)) : null,
        valueFormatted(value, isNumberValue ? int : value)));
    return (react.createElement("div", __assign({ className: (0,classNames/* default */.Z)("" + prefixCls, (_a = {}, _a[prefixCls + "-rtl"] = rtl, _a), className), style: style }, (0,omit/* default */.Z)(rest, ['value', 'countUp', 'countFrom', 'countDuration'])),
        title && react.createElement("div", { className: prefixCls + "-title" }, title),
        react.createElement("div", { className: prefixCls + "-content" },
            react.createElement(Skeleton/* default */.Z, { animation: true, loading: !!loading, text: { rows: 1, width: '100%' } },
                react.createElement("div", { className: prefixCls + "-value", style: styleValue },
                    isNumberValue ? (react.createElement("span", { className: prefixCls + "-value-int" }, eleValueWithPrefix)) : (eleValueWithPrefix),
                    decimal !== undefined || suffix ? (react.createElement("span", { className: prefixCls + "-value-decimal", style: styleDecimal },
                        (0,is/* isNumber */.hj)(Number(value)) && decimal !== undefined && "." + decimal,
                        suffix !== null && suffix !== undefined ? (react.createElement("span", { className: prefixCls + "-value-suffix" }, suffix)) : null)) : null)),
            extra && react.createElement("div", { className: prefixCls + "-extra" }, extra))));
}
var ForwardRefStatistic = (0,react.forwardRef)(Statistic);
var StatisticComponent = ForwardRefStatistic;
StatisticComponent.displayName = 'Statistic';
StatisticComponent.Countdown = countdown;
/* harmony default export */ var es_Statistic = (StatisticComponent);


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

const hasIntersectionObserver = typeof IntersectionObserver === 'function';
const observers = new Map();
const idList = [];

function createObserver(options) {
  const id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  const existing = idList.find(obj => obj.root === id.root && obj.margin === id.margin);
  let instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  const elements = new Map();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const callback = elements.get(entry.target);
      const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id,
    observer,
    elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  const {
    id,
    observer,
    elements
  } = createObserver(options);
  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      const index = idList.findIndex(obj => obj.root === id.root && obj.margin === id.margin);

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  let {
    rootRef,
    rootMargin,
    disabled
  } = _ref;
  const isDisabled = disabled || !hasIntersectionObserver;
  const [visible, setVisible] = (0, _react).useState(false);
  const [element, setElement] = (0, _react).useState(null);
  (0, _react).useEffect(() => {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        const unobserve = observe(element, isVisible => isVisible && setVisible(isVisible), {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        const idleCallback = (0, _requestIdleCallback).requestIdleCallback(() => setVisible(true));
        return () => (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  const resetVisible = (0, _react).useCallback(() => {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ })

}]);